import { useSyncExternalStore } from 'react';

/** Breakpoint under which the shell collapses its side bars into the mobile menu (matches ds.css). */
export const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)';

function query(media: string): MediaQueryList | null {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(media) : null;
}

/** `true` while `media` matches; re-renders on change. `false` where `matchMedia` is unavailable. */
export function useMediaQuery(media: string): boolean {
    return useSyncExternalStore(
        onChange => {
            const list = query(media);
            if (!list) return () => {};
            list.addEventListener('change', onChange);
            return () => list.removeEventListener('change', onChange);
        },
        () => query(media)?.matches ?? false,
        () => false,
    );
}
